import { Loader } from '@ott/utility-loader';

import { ThunkDispatch, Action } from '@reduxjs/toolkit';

export type RootState = {
  common: {
    auth: AuthState;
  };
};

export type AuthDispatch = ThunkDispatch<AuthState, void, Action>;

export type LoaderWithErrorPayload = Loader & {
  errorData?: ErrorData;
};

export type AuthState = {
  infoStatus: LoaderWithErrorPayload;
  enterStatus: LoaderWithErrorPayload;
  exitStatus: LoaderWithErrorPayload;
  registerStatus: LoaderWithErrorPayload;
  forgotStatus: LoaderWithErrorPayload;
  oAuthStatus: LoaderWithErrorPayload;
  sendPinStatus: LoaderWithErrorPayload;
  captchaParams: boolean;
  data: AuthData | undefined;
  didExit: boolean;
  didEnter: boolean;
  oAuthUrl?: string;
  oAuthModal?: Window;
};

export type Card = {
  cardMask: string;
  cardId: string;
  cardName: string;
  cardHolder: string;
  expMonth: string;
  expYear: string;
  sources: string[];
  status: string;
  isOTTCard?: boolean;
  isVirtualCard?: boolean;
};

export type AuthorizedData = {
  auth: true;
  cards: Card[];
  city: string;
  cityCode: string;
  country: string;
  cuidBanks: Record<string, string>;
  email: string;
  firstName: string;
  lastName: string;
  passengers: Passenger[];
  phone: string;
  token: string;
  userStatus: {
    type: string;
    assignment: string;
    expire?: string;
    guestMode: boolean;
  };
  vid: string;
};

export type UnAuthorizedData = {
  auth: false;
  userStatus?: {
    guestMode: boolean;
  };
  vid: string;
};

export type AuthData = AuthorizedData | UnAuthorizedData;

export type SuperagentError = {
  status: number;
  response: {
    body: {
      error: string;
    };
  };
};

type LoyaltyItem = {
  cardNumber: string;
  companyCode: string;
};

export type Passenger = {
  birthDate: string;
  documentCountry: string;
  documentExpDate: string;
  documentNumber: string;
  documentType: string;
  firstName: string;
  gender: 'M' | 'F';
  id: number;
  lastName: string;
  locales: Record<
    'ru' | 'en',
    {
      firstName: string;
      lastName: string;
      middleName: string;
      noMiddleName: boolean;
    }
  >;
  loyalty: Record<string, LoyaltyItem>;
};

export type ErrorData = string | Record<string, any>;

export type AuthError = {
  status?: number;
  data?: ErrorData;
};

export const isAuthorized = (authData: AuthData): authData is AuthorizedData => authData.auth;
